module.exports = __webpack_public_path__ + "img/internet_disabled.9aafdf9f.svg";